import { DateRange, PickersShortcutsItem } from "@mui/x-date-pickers-pro";
import { DateTime } from "luxon";

export const lookBackShortcutItems: PickersShortcutsItem<
  DateRange<DateTime>
>[] = [
  { label: "Custom Range", getValue: () => [null, null] },
  {
    label: "This Month",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("month"), today.endOf("month")];
    },
  },
  {
    label: "Last Month",
    getValue: () => {
      const today = DateTime.now();
      const prevMonth = today.minus({ months: 1 });
      return [prevMonth.startOf("month"), prevMonth.endOf("month")];
    },
  },
  {
    label: "This Quarter",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("quarter"), today.endOf("quarter")];
    },
  },
  {
    label: "Last 6 Months",
    getValue: () => {
      const today = DateTime.now();
      const prev6Months = today.minus({ months: 5 });
      return [prev6Months.startOf("month"), today];
    },
  },
  {
    label: "Last Quarter",
    getValue: () => {
      const today = DateTime.now();
      const prevQuarter = today.minus({ quarter: 1 });
      return [prevQuarter.startOf("quarter"), prevQuarter.endOf("quarter")];
    },
  },
  {
    label: "This Year",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("year"), today.endOf("year")];
    },
  },
  {
    label: "Last Year",
    getValue: () => {
      const today = DateTime.now();
      const prevYear = today.minus({ year: 1 });
      return [prevYear.startOf("year"), prevYear.endOf("year")];
    },
  },
  {
    label: "Last 2 Years",
    getValue: () => {
      const today = DateTime.now();
      const prevYear = today.minus({ year: 2 });
      return [prevYear.startOf("year"), today];
    },
  },
];

export const lookForwardShortcutItems: PickersShortcutsItem<
  DateRange<DateTime>
>[] = [
  { label: "Custom Range", getValue: () => [null, null] },
  {
    label: "This Quarter",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("quarter"), today.endOf("quarter")];
    },
  },
  {
    label: "Next 6 Months",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("day"), today.plus({ months: 6 })];
    },
  },
  {
    label: "This Year",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("year"), today.endOf("year")];
    },
  },
  {
    label: "Next 18 Months",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("day"), today.plus({ months: 18 })];
    },
  },
  {
    label: "Next 2 Years",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("day"), today.plus({ years: 2 })];
    },
  },
  {
    label: "Next 36 Months",
    getValue: () => {
      const today = DateTime.now();
      return [today.startOf("day"), today.plus({ months: 36 })];
    },
  },
];
